export const APP_VERSION = process.env.VERSION || '0.0.0';
